// extracted by mini-css-extract-plugin
export var button = "pagePreview-module--button--12f39";
export var image = "pagePreview-module--image--e5df7";
export var pagePreview = "pagePreview-module--pagePreview--6756e";
export var title = "pagePreview-module--title--06da1";